export const SHOW_LOADER="SHOW_LOADER"
export const SHOW_SUCCESS_MESSAGE="SHOW_SUCCESS_MESSAGE"
export const SHOW_ERROR_MESSAGE="SHOW_ERROR_MESSAGE"
